/** Explains the red row highlight the review table uses for disagreements. */
export function DisagreementLegend() {
  return (
    <div
      className="flex items-center gap-2 border-b border-coval-border px-4 py-2 text-xs text-coval-text-muted"
      data-testid="disagreement-legend"
    >
      <span
        aria-hidden
        className="size-3 shrink-0 rounded-sm border border-coval-danger-border bg-coval-danger-surface"
      />
      <span>
        Red rows: the primary human label disagrees with the AI review or the
        most recent experiment.
      </span>
    </div>
  )
}
